import { Languages } from "./../../../models/language.model";
import { ActivatedRoute, Router } from "@angular/router";
import { Component, OnInit } from "@angular/core";
import { UntypedFormBuilder, UntypedFormGroup } from "@angular/forms";
import { UtilService } from "src/app/services/util.service";
import { CrudService } from "src/app/services/crud.service";
import { AuthService } from "src/app/services/auth.service";
import { StatusBar } from "@capacitor/status-bar";
import { SplashScreen } from "@capacitor/splash-screen";
import { Capacitor } from "@capacitor/core";
import { listServices, Services } from "src/models/services.model";

@Component({
    selector: "app-list-reservs-restaurant",
    templateUrl: "./list-reservs-restaraunt.html",
    styleUrls: ["./list-reservs-restaraunt.scss"],
    providers: [],
    standalone: false
})
export class ReservationRequestsComponent implements OnInit {
  reservs = [];
  Languages = Languages;
  services: { value: number; label: string }[] = listServices;
  showModalEdit = true;
  reservSelected = null;
  selectNumber = 0;
  filterForm: UntypedFormGroup;
  showModalFilter = false;
  reservaId: any;
  isFiltered = false;
  constructor(
    public fb: UntypedFormBuilder,
    public util: UtilService,
    public router: Router,
    private crud: CrudService,
    public route: ActivatedRoute,
    private auth: AuthService
  ) {}

  loadData(event?: any) {
    this.crud.getData("restaurante/reserva/listar").subscribe(
      (response: { data: any }) => {
        this.isFiltered = false;
        if (this.reservaId) {
          this.reservs = response.data.filter((e) => e.id == this.reservaId);
        } else {
          this.reservs = response.data;
        }
        if (event) {
          event.target.complete();
        }
      },
      (error) => {
        this.util.showToast("Failed to request");
      }
    );
  }

  getServiceDescription(service: number) {
    return this.services.filter((s) => s.value === service)[0].label;
  }

  loadSearchData(event?: any) {
    this.crud
      .postData("restaurante/reserva/busca", null, this.filterForm.value)
      .subscribe(
        (response: { data: any }) => {
          this.isFiltered = true;
          this.reservs = response.data;

          if (event) {
            event.target.complete();
          }
        },
        (error) => {
          this.util.showToast("Failed to request");
        }
      );
  }

  ngOnInit() {}

  ionViewWillEnter() {
    this.route.params.subscribe(async (params) => {
      if (params.id) {
        this.reservaId = params.id;
      }
      if (Capacitor.isNativePlatform()) {
        await StatusBar.hide();
        await SplashScreen.hide();
      }
      this.filterForm = this.fb.group({
        nomeCliente: [""],
        dataInicio: [""],
        dataFim: [""],
      });
      this.loadData();
    });
  }

  getStatus(reserv: any): { title: string; color: string } {
    if (reserv.dataReservaAceita) {
      return {
        title: "Accept",
        color: "success",
      };
    } else if (reserv.dataReservaCancelada) {
      return {
        title: "Canceled",
        color: "danger",
      };
    } else if (reserv.dataReservaFinalizada) {
      return {
        title: "Done",
        color: "success",
      };
    } else if (reserv.dataReservaRecusada) {
      return {
        title: "Declined",
        color: "danger",
      };
    }

    return null;
  }

  accept(reserv: any, index: number) {
    this.crud.postData(`restaurante/reserva/aceitar?id=${reserv.id}`).subscribe(
      (response) => {
        if (!reserv.dataReservaCliente) {
          this.crud
            .postData(`restaurante/reserva/finalizar?id=${reserv.id}`)
            .subscribe(
              (response) => {},
              (error) => {}
            );
        }
        this.util.showToast("Reservation confirmed successfully");
        this.deleteItem(index);
      },
      (error) => {
        this.util.showToast("Failed to accept your reservation");
      }
    );
  }

  deleteItem(index: number) {
    this.reservs.splice(index, 1);
  }

  denied(reserv: any, index: number) {
    // this.crud.postData(`restaurante/reserva/recusar?id=${reserv.id}`).subscribe(
    this.crud
      .postData(`restaurante/reserva/recusar`, "", {
        reservaId: reserv.id,
        motivo: "",
        usuarioId: this.auth.user.id,
      })
      .subscribe(
        (response) => {
          this.util.showToast("Reservation declined successfully");
          this.deleteItem(index);
        },
        (error) => {
          this.util.showToast("Failed to decline your reservation");
        }
      );
  }

  editReserv(reserv) {
    this.showModalEdit = true;
    this.reservSelected = reserv;

    this.selectNumber = this.reservSelected.quantidadePessoas;
  }

  clearModalEdit() {
    this.reservSelected = null;
    this.showModalEdit = false;
  }

  confirmEdition() {
    if (this.reservSelected) {
      const { id, quantidadePessoas } = this.reservSelected;

      const params = {
        "reserva-id": id,
        "quantidade-pessoas": this.selectNumber,
      };

      this.crud.patchData("restaurante/reserva", params).subscribe(
        (response) => {
          this.loadData();
          this.util.showToast("Reservation changed successfully");
          this.clearModalEdit();
        },
        (error) => {
          this.util.showToast("An error occurred while editing");
          this.clearModalEdit();
        }
      );
    }
  }

  showFilter() {
    this.filterForm.reset();
    this.showModalFilter = true;
  }

  filterData() {
    this.reservaId = "";
    if (
      this.filterForm.value.nomeCliente ||
      this.filterForm.value.dataInicio ||
      this.filterForm.value.dataFim
    )
      this.loadSearchData();
    else this.loadData();
    this.showModalFilter = false;
  }
}
